import { Card } from "../../dumbs"
import { Input } from "../../input"
import { Button } from "../../button"
import { useToast } from "../../../hooks/useToast"
import { useLocalDataMutation } from "../../../hooks/useBoundData"
import { useState } from "react"
import { MUTATION_CALLS } from "../../../consts"
import { BanSolid } from "../../Icons"
import { Loader } from "../../loaders"
import { _empty } from "../../../helpers/utils"

function formatDateString(date) {
    return date.replace(/-/g, "/");
}

const CreateInsight = ({ filter = {}, className = "", stats }) => {
    const toast = useToast()
    const { executeCall: createBoard, loader: createLoader } = useLocalDataMutation(MUTATION_CALLS.create_board)

    const { loader: bulkAddLoader, executeCall: bulkAdd } = useLocalDataMutation({ ...MUTATION_CALLS.content_board_bulk_add, endpoint: MUTATION_CALLS.content_board_bulk_add.endpoint + '?' + new URLSearchParams({ ...filter, limit: 500 }).toString() })
    const [boardName, setBoardName] = useState("")
    const createNewBroad = async () => {
        if (!stats?.total_posts) {
            return
        }
        // if (stats?.total_posts > 500) {
        //     toast("You are giving to much content to process", BanSolid)
        //     return
        // }
        if (!boardName) {
            toast("Please give your analysis a name", BanSolid)
            return
        }
        if (_empty(filter)) {
            console.error("filter is empty")
            return
        }
        let bName = `${boardName} ${(filter?.post_date__gte && filter?.post_date__lte) ? ` (${formatDateString(filter?.post_date__gte)} - ${formatDateString(filter?.post_date__lte)})` : ""}`
        const _payload = {
            "name": bName,
            "board_type": 1,
            "analytics_type": 1,
            "category": 1
        }

        const board = await createBoard(_payload)

        if (!board) {
            toast("Something went wrong while creating the board", BanSolid)
            return

        }
        const details = await bulkAdd({
            board_id: board?.id
        })
        if (!details) {
            toast("Something went wrong while adding contents to the board", BanSolid)
            return
        }
        setBoardName("")
        toast(`Successfully sent ${details.count} for analysis - ${board?.name}`, undefined, 6000)

    }


    return <Card className={`padding-x-9x padding-y-6x ${className}`}>
        <h3 className="headline-medium-highlight primary-fg">Content analysis</h3>
        <Input value={boardName} onChange={e => setBoardName(e?.target?.value)} className="margin-y-5x" placeholder={`Give your analysis a name...`}></Input>

        <div className="flex a-center gap-8">
            <Button
                disabled={createLoader || bulkAddLoader}
                onClick={createNewBroad}
                className="no-flex-shrink"
                beforeElement={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.0039 9.73438L12.8633 13.9844C12.9961 14.3496 12.8633 14.7148 12.5312 14.8809C12.4316 14.9141 12.332 14.9141 12.2656 14.9141C12 14.9141 11.7344 14.7812 11.6348 14.5488L11.4688 14.1172H9.34375C9.31055 14.1172 9.31055 14.1172 9.31055 14.1172L9.14453 14.5156C8.97852 14.8477 8.61328 14.9805 8.24805 14.8477C7.91602 14.7148 7.7832 14.3164 7.91602 13.9844L9.77539 9.73438C10.0078 9.23633 10.7715 9.23633 11.0039 9.73438ZM9.9082 12.7891H10.8711L10.4062 11.6602L9.9082 12.7891ZM14.6562 9.33594C15.0215 9.33594 15.3203 9.63477 15.3203 10V14.25C15.3203 14.6484 15.0215 14.9141 14.6562 14.9141C14.2578 14.9141 13.9922 14.6484 13.9922 14.25V10C13.9922 9.63477 14.2578 9.33594 14.6562 9.33594ZM19.7031 12.9219H18.375V14.5156H19.7031C20.1348 14.5156 20.5 14.8809 20.5 15.3125C20.5 15.7773 20.1348 16.1094 19.7031 16.1094H18.375V16.375C18.375 17.5703 17.4121 18.5 16.25 18.5H15.9844V19.8281C15.9844 20.293 15.6191 20.625 15.1875 20.625C14.7227 20.625 14.3906 20.293 14.3906 19.8281V18.5H12.7969V19.8281C12.7969 20.293 12.4316 20.625 12 20.625C11.5352 20.625 11.2031 20.293 11.2031 19.8281V18.5H9.60938V19.8281C9.60938 20.293 9.24414 20.625 8.8125 20.625C8.34766 20.625 8.01562 20.293 8.01562 19.8281V18.5H7.75C6.55469 18.5 5.625 17.5703 5.625 16.375V16.1094H4.29688C3.83203 16.1094 3.5 15.7773 3.5 15.3125C3.5 14.8809 3.83203 14.5156 4.29688 14.5156H5.625V12.9219H4.29688C3.83203 12.9219 3.5 12.5898 3.5 12.125C3.5 11.6934 3.83203 11.3281 4.29688 11.3281H5.625V9.73438H4.29688C3.83203 9.73438 3.5 9.40234 3.5 8.9375C3.5 8.50586 3.83203 8.14062 4.29688 8.14062H5.625V7.875C5.625 6.71289 6.55469 5.75 7.75 5.75H8.01562V4.42188C8.01562 3.99023 8.34766 3.625 8.8125 3.625C9.24414 3.625 9.60938 3.99023 9.60938 4.42188V5.75H11.2031V4.42188C11.2031 3.99023 11.5352 3.625 12 3.625C12.4316 3.625 12.7969 3.99023 12.7969 4.42188V5.75H14.3906V4.42188C14.3906 3.99023 14.7227 3.625 15.1875 3.625C15.6191 3.625 15.9844 3.99023 15.9844 4.42188V5.75H16.25C17.4121 5.75 18.375 6.71289 18.375 7.875V8.14062H19.7031C20.1348 8.14062 20.5 8.50586 20.5 8.9375C20.5 9.40234 20.1348 9.73438 19.7031 9.73438H18.375V11.3281H19.7031C20.1348 11.3281 20.5 11.6934 20.5 12.125C20.5 12.5898 20.1348 12.9219 19.7031 12.9219ZM16.7812 16.375V7.875C16.7812 7.60938 16.5156 7.34375 16.25 7.34375H7.75C7.45117 7.34375 7.21875 7.60938 7.21875 7.875V16.375C7.21875 16.6738 7.45117 16.9062 7.75 16.9062H16.25C16.5156 16.9062 16.7812 16.6738 16.7812 16.375Z" fill="white" />
                </svg>
                }>Analyze content {createLoader || bulkAddLoader ? <Loader></Loader> : null}</Button>
            {stats?.total_posts ? stats?.total_posts > 500 ? <span className={`caption-highlight nc50-fg `}>
                Limit Reached : Only first 500 posts will be analyzed
            </span> : <span className={`caption-highlight ${stats?.total_posts > 500 ? "negative-fg" : "nc50-fg"} `}>{stats?.total_posts} posts will be analyzed</span> : null}
        </div>
    </Card>
}


export { CreateInsight }